module.exports = __webpack_public_path__ + "files/e5cc24a388052e08bfb07f1951518019.png";